import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useLoadAgreements } from '../hooks/useLoadAgreements'

type TAvailablePaymentMethods = ReturnType<typeof useLoadAgreements>

const [Provider, useAgreementsCtx] = createContext<TAvailablePaymentMethods>(`Agreements`)

type TProps = RequiredChildren

/**
 * Context provider for VAM agreements that the customer can/has to agree with.
 * The data could change as the customer is filling the form
 * because we might get more info about his previous choices (what he agreed to already).
 * Use the `useAgreements` to access the payment methods.
 */
export const AgreementProvider: React.FC<TProps> = ({ children }) => {
  const agreements = useLoadAgreements()

  return <Provider value={agreements}>{children}</Provider>
}

export { useAgreementsCtx }
